import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppComponent} from './app.component';
import {FooterComponent, HeaderComponent, SharedModule} from './shared';
import {AppRoutingModule} from './app-routing.module';
import {APP_BASE_HREF} from '@angular/common';
import {BsDropdownModule, ModalModule} from 'ngx-bootstrap';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {ApiService, AppCommonModule, HttpLoaderFactory, LocaleConfig} from '@common-lib';
import {PagesModule} from './pages';
import {ToasterModule} from 'angular2-toaster';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {environment} from '../environments/environment';
import {CoreModule} from './core';
import { UploadAssetsWidgetComponent } from './components/upload-assets-widget/upload-assets-widget.component';
import { DashboardCommonStatsComponent } from './components/dashboard-common-stats/dashboard-common-stats.component';
import { LightboxModule } from 'ngx-lightbox';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [AppComponent, FooterComponent, HeaderComponent, UploadAssetsWidgetComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppCommonModule.forRoot({
      logLevel: environment.LOG_LEVEL,
      apiConfig: {
        API_URL: environment.API_URL
      },
      localeConfig: {
        DEFAULT_LOCALE: environment.DEFAULT_LOCALE,
        DEFAULT_LANGUAGE: environment.DEFAULT_LANGUAGE,
        SECTION: 'webpanel'
      }
    }),
    CoreModule,
    SharedModule,
    PagesModule,
    AppRoutingModule,
	  LightboxModule,
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    ToasterModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [ApiService, LocaleConfig]
      }
    }),
    NgSelectModule,
    FormsModule
  ],
  providers: [
    {provide: APP_BASE_HREF, useValue: environment.BASE_PATH}
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts